<template>
  <div>
    <!--头部信息-->
    <public-title>管理员的返利中心</public-title>
    <admin-rebate-title :titleInfo="titleInfo" @select="handleSelect"/>
    <div class="bg-white pb-4">
      <div class="d-center-between pl-3 pr-3">
        <el-row class="w-100 mt-3 text-left">
          <el-col :span="6">
            <el-select class="mt-1" v-model="rebatetype" @change="rbtchange">
              <el-option label="全部" value="" />
              <el-option label="度假产品" value="7" />
              <el-option label="景区门票" value="6" />
            </el-select>
          </el-col>
          <el-col :span="18">
            <!--tab选项卡-->
            <el-menu mode="horizontal" class="w-80 inline" @select="handleSelect" :default-active="activeName">
              <el-menu-item index="all">总计返利</el-menu-item>
              <el-menu-item index="0">可提返利</el-menu-item>
              <el-menu-item index="1">已提返利</el-menu-item>
              <el-menu-item index="2">冻结中
                <el-tooltip class="item" effect="dark" content="平台打款处理中" placement="top-start">
                  <i class="el-icon-info h6 text-info"/>
                </el-tooltip> 
              </el-menu-item>
            </el-menu>
          </el-col>
        </el-row>
      </div>
      <!--搜索框-->
      <p class="text-link text-right pr-3" @click="rbtchange">搜索</p>
      <div class="rounded p-3 pb-0 d-center-between flex-wrap">
        <div class="d-center w-35 mb-3">
          <left-text leftText="购买时间" />
          <el-date-picker class="w-100" size="small" v-model="timeStamp" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" />
        </div>
        <left-text-border class="w-35 mb-3" leftText="产品名称" v-model="searchName" />
        <left-text-border class="w-35 mb-3" leftText="门店名称" v-model="storeName" />
        <left-text-border class="w-35 mb-3" leftText="购买人手机号" v-model="buyerMob" />
      </div>
      <admin-display-list :adminRebateArr="adminRebateArr"/>
      <el-pagination background layout="prev, pager, next" class="mt-4" v-show="total > 0"
        :total="total" :page-size="10" :current-page="current" @current-change="currentChange" />
    </div>
  </div>
</template>

<script>
  import AdminDisplayList from './AdminDisplayList'
  import AdminRebateTitle from './AdminRebateTitle'

  export default {
    name: 'AdminRebateIncome',
    components :{
        AdminDisplayList,
        AdminRebateTitle
    },
    data() {
      return {
        activeName: 'all',                                  //默认选择
        timeStamp: '',                                      //选中时间戳
        searchName: '',                                     //选中名字
        storeName: '',
        beginCtrol:false,                                   //是否显示控制面板
        adminRebateArr: [],
        titleInfo: {},
        total: 1,
        current: 1,
        buyerMob: '',
        rebatetype: ''
      }
    },
    created() {
      this.getRebateInfo();
    },
    methods: {
      rbtchange () {
        this.current = 1
        this.getRebateInfo()
      },
      //切换tab
      handleSelect(key) {
        this.current = 1;
        this.activeName = key
        this.getRebateInfo()
      },
      // 获取管理员查看返利列表
      async getRebateInfo() {
        let start = this.timeStamp ? this.timeStamp[0].getTime() / 1000 : '';
        let end = this.timeStamp ?  this.timeStamp[1].getTime() / 1000 : '';
        let res = await this.$axios.post('/pc/Admin/getProductRebate',{
          start,
          end,
          withdraw: this.activeName,
          storeName: this.storeName,
          productName: this.searchName,
          occupant_mobile: this.buyerMob,
          page: this.current,
          num: 10,
          style: this.rebatetype
        })
        if (res.code === '00000' || res.code === '99999') {
          this.adminRebateArr = res.data
          this.total = res.count
          this.titleInfo = {
            allRebate: res.allRebate,
            canRebate: res.canRebate,
            freeze: res.freeze,
            rebated: res.rebated
          }
        }
      },
      // 分页
      currentChange (val) {
        this.current = val
        this.getRebateInfo()
      }
    }
  }
</script>

<style lang="scss" scoped>
.inline{
  .el-menu-item{
    height: 45px;
    line-height: 45px
  }
}
</style>
